import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterJournal } from '@/api/model/interfaces';

export default class RegisterJournalOdata extends OdataManager<RegisterJournal> {}
